const {registerModule} = window;

class CareersList {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  initialize() {
    this.bindUI();
    this.bindEvents();
    setTimeout(() => {
      this.updateFilters(this.element);
    }, 100);
  }

  unmount() {
    this.ui.$departmentFilter.forEach(($el) => {
      $el.removeEventListener('change', this.onCareersChange.bind(this));
    });
    this.ui.$locationFilter.forEach(($el) => {
      $el.removeEventListener('change', this.onCareersChange.bind(this));
    });
  }

  bindUI() {
    this.ui = {};
    this.ui.$departmentFilter = [...this.element.querySelectorAll('[data-ref="departments-list"]')];
    this.ui.$locationFilter = [...this.element.querySelectorAll('[data-ref="locations-list"]')];
    this.ui.$careersContainer = [...this.element.querySelectorAll('[data-ref="careers"]')];
  }

  bindEvents() {
    this.ui.$careersContainer.forEach(($el) => {
      $el.append(this.createNoDepartmentResults());
    });

    this.ui.$departmentFilter.forEach(($el) => {
      $el.addEventListener('change', this.onCareersChange.bind(this));
    });
    this.ui.$locationFilter.forEach(($el) => {
      $el.addEventListener('change', this.onCareersChange.bind(this));
    });
  }

  createNoDepartmentResults() {
    const $noDepartmentResults = document.createElement('div');
    const $message = document.createElement('p');

    $noDepartmentResults.className = 'careers-list__item';
    $noDepartmentResults.setAttribute('aria-hidden', 'true');
    $noDepartmentResults.setAttribute('data-ref', 'no-dept-results');
    $noDepartmentResults.hidden = true;
    $message.textContent = 'No jobs match your search.';

    $noDepartmentResults.append($message);

    return $noDepartmentResults;
  }

  updateFilters(target) {
    this.careersResetList(target);
    this.careersFilterList(target);
  }

  onCareersChange(e) {
    let target;
    if (e) {
      target = e.currentTarget.closest('[data-module="CareersList"]');
    } else {
      target = this.element;
    }
    this.updateFilters(target);
    this.careersResetScroll(target);
  }

  careersResetList(element) {
    const departments = [...element.querySelectorAll('[data-department-group]')];

    const jobs = [...element.querySelectorAll('[data-location]')];
    const noDeptResults = element.querySelector('[data-ref="no-dept-results"]');

    noDeptResults.hidden = true;

    // Reset visibility
    departments.forEach((item) => {
      item.hidden = false;
    });

    jobs.forEach((item) => {
      item.hidden = false;
    });
  }

  careersFilterList(element) {
    const $modDepartmentFilter = element.querySelector('[data-ref="departments-list"]');
    const $modLocationFilter = element.querySelector('[data-ref="locations-list"]');

    const $departments = [...element.querySelectorAll('[data-department-group]')];
    const $jobs = [...element.querySelectorAll('[data-location]')];

    const deptValue = $modDepartmentFilter ? $modDepartmentFilter.value : false;
    const locValue = $modLocationFilter ? $modLocationFilter.value : false;

    let result = $jobs;

    if (deptValue && deptValue !== 'None') {
      result = $jobs.filter((item) => {
        const regex = new RegExp(deptValue);
        return item.dataset.department.match(regex);
      });
    }

    if (locValue && locValue !== 'None') {
      result = result.filter((item) => {
        return item.dataset.location == locValue;
      });
    }

    $jobs.forEach((item) => {
      item.hidden = true;
    });

    if (result.length) {
      result.forEach((item) => {
        item.hidden = false;
      });
    } else {
      const noDeptResults = element.querySelector('[data-ref="no-dept-results"]');
      noDeptResults.hidden = false;
    }

    // If all items are hidden in the department section,
    // then hide that department.
    $departments.forEach((dept) => {
      const sectionLoc = [...dept.querySelectorAll('[data-location]')];

      const hidden = sectionLoc.filter((loc) => {
        return loc.hidden == true;
      });

      if (hidden.length == sectionLoc.length) {
        dept.hidden = true;
      }
    });
  }

  careersResetScroll(element) {
    // grab fresh heights
    let navHeight = getComputedStyle(document.documentElement).getPropertyValue('--nav-height');

    // if navHeight is a rem value, we have some calculating to do
    if (navHeight.endsWith('rem')) {
      navHeight = parseInt(navHeight) * parseInt(getComputedStyle(document.documentElement).fontSize);
    }

    // Reset scroll position to top of careers section
    const careersTop = (element.getBoundingClientRect().top + document.documentElement.scrollTop) - parseInt(navHeight);
    setTimeout(() => {
      window.scrollTo({
        top: careersTop,
        left: 0,
      });
    }, 150);
  }
}

registerModule('CareersList', CareersList);
